import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";

const Checkout = () => {
  const { cartItems,clearCart } = useCart();
  const [isDineIn, setIsDineIn] = useState(true);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [tableNumber, setTableNumber] = useState("");
  const navigate = useNavigate();

  const handleToggle = () => setIsDineIn((prev) => !prev);

  const totalAmount = cartItems.reduce(
    (sum, item) => sum + item.price * (item.quantity || 1),
    0
  );

  const handleSubmit = async () => {
  if (!name || !phone || (isDineIn && !tableNumber)) {
    alert("Please fill all required fields.");
    return;
  }

  const orderType = isDineIn ? "dinein" : "takeout";
  const order = {
    type: orderType,
    name,
    phone,
    tableNumber: isDineIn ? tableNumber : null,
    items: cartItems,
    total: totalAmount,
    timestamp: new Date().toISOString(),
  };

  try {
    // Save under customers/{phone}/orders/
    await addDoc(collection(db, "customers", phone, "orders"), order);
    clearCart(); 
    alert("Order placed successfully!");
    navigate("/orders", { state: { phone } }); // Pass phone to orders page
  } catch (error) {
    console.error("Error saving order:", error);
    alert("Failed to place order.");
  }
};

  return (
    <div className="max-w-4xl py-20 mx-auto p-6 bg-white shadow-xl rounded-lg mt-6 text-gray-800">
      <h1 className="text-2xl font-bold mb-4">Checkout</h1>

      {/* Toggle Switch */}
      <div className="flex items-center justify-center gap-4 mb-6">
        <span className={isDineIn ? "font-semibold text-green-700" : "text-gray-500"}>Dine In</span>
        <button
          onClick={handleToggle}
          className={`w-14 h-8 rounded-full flex items-center px-1 transition duration-300 ${
            isDineIn ? "bg-green-400" : "bg-blue-700"
          }`}
        >
          <div
            className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform ${
              isDineIn ? "translate-x-0" : "translate-x-6"
            }`}
          />
        </button>
        <span className={!isDineIn ? "font-semibold text-blue-700" : "text-gray-500"}>Take Out</span>
      </div>

      {/* Message */}
      {isDineIn ? (
        <p className="mb-4 text-green-600 font-medium">
          Your order will be delivered to your table in 5 minutes.
        </p>
      ) : (
        <p className="mb-4 text-blue-600 font-medium">
          Your order will be available at the take-out counter in 5 minutes.
        </p>
      )}

      {/* Form */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <input
          type="text"
          placeholder="Your Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          className="border p-3 rounded-md w-full"
        />
        <input
          type="tel"
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="border p-3 rounded-md w-full"
        />
        {isDineIn && (
          <input
            type="text"
            placeholder="Table Number"
            value={tableNumber}
            onChange={(e) => setTableNumber(e.target.value)}
            className="border p-3 rounded-md w-full"
          />
        )}
      </div>

      {/* Cart Items */}
      <h2 className="text-xl font-semibold mb-2">Your Items</h2>
      <ul className="mb-6 divide-y divide-gray-200">
        {cartItems.length === 0 ? (
          <li className="py-2 text-gray-500">Your cart is empty.</li>
        ) : (
          cartItems.map((item, index) => (
            <li key={index} className="flex justify-between items-center py-2">
              <div>
                <p className="font-medium">{item.name}</p>
                <p className="text-sm text-gray-500">Qty: {item.quantity || 1}</p>
              </div>
              <p>₹{(item.price * (item.quantity || 1)).toFixed(2)}</p>
            </li>
          ))
        )}
      </ul>

      {/* Total + Submit */}
      <div className="flex justify-between items-center mt-4">
        <div className="text-lg font-bold">Total: ₹{totalAmount.toFixed(2)}</div>
        <button
          onClick={handleSubmit}
          className="bg-amber-600 hover:bg-amber-700 text-white px-6 py-2 rounded-lg font-semibold"
        >
          Proceed to Payment
        </button>
      </div>
    </div>
  );
};

export default Checkout;
